import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderStatusChange } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreateOrderStatusChange } from './interface';

export const createOrderStatusChange = createAsyncThunk(
  'orderStatusChange/createOrderStatusChange',
  async (values: CreateOrderStatusChange, { rejectWithValue }) => {
    try {
      const response = await OrderStatusChange.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);